import "core-js/modules/es6.object.assign";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import cx from 'classnames';
import React from 'react';
import { config } from '../helpers/config';
import Loader from './Loader';
var Button = React.forwardRef(function (_ref, ref) {
  var _cx;

  var active = _ref.active,
      actionType = _ref.actionType,
      as = _ref.as,
      children = _ref.children,
      className = _ref.className,
      disabled = _ref.disabled,
      fullWidth = _ref.fullWidth,
      iconOnly = _ref.iconOnly,
      loading = _ref.loading,
      noContrast = _ref.noContrast,
      noRadius = _ref.noRadius,
      size = _ref.size,
      type = _ref.type,
      url = _ref.url,
      opts = _objectWithoutPropertiesLoose(_ref, ["active", "actionType", "as", "children", "className", "disabled", "fullWidth", "iconOnly", "loading", "noContrast", "noRadius", "size", "type", "url"]);

  var classes = cx(className, (_cx = {
    button: type !== 'reset',
    'button--reset': type === 'reset',
    'button--default': type === 'default',
    'button--primary': type === 'primary',
    'button--secondary': type === 'secondary',
    'button--teal': type === 'teal',
    'button--danger': type === 'danger',
    'button--outlinePrimary': type === 'outlinePrimary',
    'button--small': size === 'small',
    'button--xsmall': size === 'xsmall',
    'button--fullWidth': fullWidth,
    'button--icon': iconOnly,
    'button--noContrast': noContrast
  }, _cx[config.classes.active] = active, _cx[config.classes.loading] = loading, _cx['u-borderRadius--remove'] = noRadius, _cx));
  var Component = as;
  var buttonProps = Object.assign({
    className: classes,
    disabled: disabled || loading,
    ref: ref
  }, opts);

  if (url) {
    buttonProps.href = url;
    Component = 'a';
  }

  if (Component !== 'a') {
    buttonProps.type = actionType;
  }

  return React.createElement(Component, buttonProps, type === 'reset' ? children : React.createElement("span", null, children), loading && React.createElement(Loader, null));
});
Button.defaultProps = {
  as: 'button',
  actionType: 'button'
};
export default Button;